const timelineData = [
  {
    phase: "第一阶段",
    title: "信息爆发",
    icon: "ri-radar-line",
    text: "原始爆料或公开素材出现，传播进入高速度扩散期。此时信源单一、细节有限，是反转率最高的阶段。",
  },
  {
    phase: "第二阶段",
    title: "首次回应",
    icon: "ri-megaphone-line",
    text: "当事人或工作室通过声明、长文等发声。回应的时机、措辞与是否直面核心问题，决定后续舆论走向。",
  },
  {
    phase: "第三阶段",
    title: "二次发酵",
    icon: "ri-repeat-line",
    text: "旧料考古、圈内发声与商务动作交叉出现。事件从单一叙事演变为多方博弈，公众开始交叉验证。",
  },
  {
    phase: "第四阶段",
    title: "定性 / 降温",
    icon: "ri-sun-foggy-line",
    text: "随着程序性结论（如诉讼进展、公开道歉、处理结果）逐步落地，情绪高潮回落，进入长尾复盘期。",
  },
];

export default function Timeline() {
  return (
    <section id="timeline" className="bg-secondary-100/60 py-14 md:py-20">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6 lg:px-10">
        <div className="flex flex-col items-center text-center">
          <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary-700">
            <i className="ri-route-line text-base"></i>
            事件走向
          </span>
          <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            一条事件的典型生命周期
          </h2>
          <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">
            看懂它处在哪个阶段，就不会被单一信息带着走。这也是我们安排内容更新的基本坐标系。
          </p>
        </div>

        <div className="relative mt-12">
          <div className="absolute left-4 top-0 h-full w-px bg-primary-200 md:left-1/2 md:-translate-x-px"></div>
          <div className="space-y-8 md:space-y-0">
            {timelineData.map((t, i) => (
              <div
                key={t.phase}
                className={`relative flex flex-col gap-4 pl-12 md:grid md:grid-cols-2 md:items-center md:gap-12 md:pl-0 ${
                  i % 2 === 0 ? "" : ""
                }`}
              >
                <span className="absolute left-1.5 top-1 flex h-6 w-6 items-center justify-center rounded-full bg-background-50 ring-2 ring-primary-400 md:left-1/2 md:top-1/2 md:-translate-x-1/2 md:-translate-y-1/2">
                  <span className="h-2 w-2 rounded-full bg-primary-600"></span>
                </span>
                <div
                  className={`md:py-4 ${
                    i % 2 === 0
                      ? "md:col-start-1 md:pr-4 md:text-right"
                      : "md:col-start-2 md:pl-4"
                  }`}
                >
                  <div className="inline-flex items-center gap-2">
                    <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600 text-background-50">
                      <i className={`${t.icon} text-lg`}></i>
                    </span>
                    <div className="text-left">
                      <span className="text-xs font-semibold text-primary-700">{t.phase}</span>
                      <p className="font-heading text-base font-bold text-foreground-950">{t.title}</p>
                    </div>
                  </div>
                </div>
                <div className={`md:py-4 ${i % 2 === 0 ? "md:col-start-2 md:pl-4" : "md:col-start-1 md:pr-4 md:text-right"}`}>
                  <div className="rounded-lg bg-background-50 p-5 ring-1 ring-background-200">
                    <p className="text-sm leading-relaxed text-foreground-600">{t.text}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}